import {
    Component,
    EventEmitter,
    Input,
    Output,
    inject,
} from '@angular/core';
import { AuthService } from '@services';
import { DxButtonModule, DxDropDownButtonModule, DxToolbarModule, } from 'devextreme-angular';
import { PermissionType, AccessType, InvoicePurchaseOrderAction, InvoicePurchaseOrderStatus, } from '@services/web-api-client';

@Component({
    selector: 'app-invoice-purchase-order-details-toolbar',
    standalone: true,
    imports: [DxToolbarModule, DxButtonModule, DxDropDownButtonModule],
    templateUrl: './invoice-purchase-order-details-toolbar.component.html',
})
export class InvoicePurchaseOrderDetailsToolbarComponent {
    @Input() number: string | null = null;
    @Input() status: InvoicePurchaseOrderStatus | undefined;
    @Input() actions: InvoicePurchaseOrderAction[] | null = null;
    @Input() isReadOnly: boolean = false;
    @Input() isSubmitting: boolean = false;
    @Input() isLoading: boolean = false;
    @Input() isExporting: boolean = false;

    @Output() cancelClick = new EventEmitter<void>();
    @Output() save = new EventEmitter<InvoicePurchaseOrderAction>();
    @Output() exportClick = new EventEmitter<void>();

    protected auth = inject(AuthService);
    public InvoicePurchaseOrderAction = InvoicePurchaseOrderAction;

    canShowButton(action: InvoicePurchaseOrderAction): boolean {
        if (this.isLoading) return false;

        if (!this.number && !this.isReadOnly) {
            return ((action === InvoicePurchaseOrderAction.Submit && this.canSubmit) || action === InvoicePurchaseOrderAction.SaveAsDraft);
        }

        if (this.number && !this.isReadOnly && action === InvoicePurchaseOrderAction.Save) {
            return true;
        }

        return this.actions?.includes(action) ?? false;
    }

    get canSubmit (): boolean {
        return this.auth.checkPermission(PermissionType.InvoicePurchaseSubmit, AccessType.Edit);
    }

    get canExport(): boolean {
        return !this.isLoading && !!this.number && !!this.status && this.status !== InvoicePurchaseOrderStatus.Draft;
    }

    onButtonClick(status: InvoicePurchaseOrderAction) {
        this.save.emit(status);
    }
}
